import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { unauthenticated } from '@datev/ngx-dcal';
import { map, Observable } from 'rxjs';
import {
  DownloadFilter,
  DownloadType,
  Package,
  PackageDto,
  PackagePage,
  PackagePageDto,
} from '../../model';

@Injectable({
  providedIn: 'root',
})
export class PackageService {
  private apiUrl = 'api/amr/download-portal-api/v1/base-software';

  constructor(private readonly http: HttpClient) {}

  public getPackageList(
    filter: DownloadFilter,
    pageNumber: number,
    pageSize: number,
  ): Observable<Array<Package>> {
    const params = this.getQueryParams(filter, pageNumber, pageSize);

    return this.http
      .get<
        Array<PackageDto>
      >(`${this.apiUrl}?${params.toString()}`, { context: unauthenticated() })
      .pipe(
        map(packages =>
          packages.map(packageDto => this.mapPackageDtoToPackage(packageDto)),
        ),
      );
  }

  public getPackagePage(
    filter: DownloadFilter,
    pageNumber: number,
    pageSize: number,
  ): Observable<PackagePage> {
    const params = this.getQueryParams(filter, pageNumber, pageSize);

    return this.http
      .get<PackagePageDto>(`${this.apiUrl}?${params.toString()}`, {
        context: unauthenticated(),
      })
      .pipe(
        map(packagePageDto => {
          const content =
            packagePageDto.content
              ?.map(packageDto => this.mapPackageDtoToPackage(packageDto)) || [];
          return { ...packagePageDto, content };
        }),
      );
  }

  private getQueryParams(
    filter: DownloadFilter,
    pageNumber: number,
    pageSize: number,
  ): HttpParams {
    let params = new HttpParams();

    if (!filter.mainComponents || filter.mainComponents === '') {
      throw new Error(
        'Unsupported State Exception: main components should always contain at least one value',
      );
    }

    params = params.append('main_components', filter.mainComponents);
    params = params.append('is_archived', filter.isArchived);
    params = params.append('page', pageNumber);
    params = params.append('page_size', pageSize);

    return params;
  }

  public getPackageById(id: string): Observable<Package> {
    return this.http
      .get<PackageDto>(`${this.apiUrl}/${id}`, {
        context: unauthenticated(),
      })
      .pipe(map(packageDto => this.mapPackageDtoToPackage(packageDto)));
  }

  private mapPackageDtoToPackage(packageDto: PackageDto): Package {
    const displayTitle = packageDto.version
      ? `${packageDto.name} ${packageDto.version}`
      : packageDto.name;

    return {
      ...packageDto,
      displayTitle,
      type: DownloadType.PAKET,
    };
  }
}
